import Model, { belongsTo, attr } from '@ember-data/model';
import { copyable } from 'eflex/decorators';
import AnimationEvents from 'eflex/constants/jem/instruction-animation-events';

@copyable
class WorkInstructionAnimation extends Model {
  @attr('string') object;
  @attr('string') event;
  @attr('string') animation;
  @attr('string') fillColor;
  @attr('string') strokeColor;
  @attr('string') bolt;
  @attr('string') color;
  @attr('string') textBoxColor;
  @attr('string') dataType;
  @attr('string') textValue;
  @attr('string') selectedValueOption;
  @attr('string') selectedValueOptionId;
  @attr('string') processDataOptionId;

  @belongsTo('work-instruction-hardware-trigger-config', {
    async: false,
    inverse: 'animations',
  }) workInstructionHardwareTriggerConfig;

  get copyableOptions() {
    return {
      ignoreAttributes: new Set(['workInstructionHardwareTriggerConfig']),
    };
  }

  get isPassOrReject() {
    return this.event === AnimationEvents.PASS || this.event === AnimationEvents.REJECT;
  }
}

export default WorkInstructionAnimation;
